import { render, staticRenderFns } from "./ProcessOrganizational.vue?vue&type=template&id=06cd0c90&scoped=true"
import script from "./ProcessOrganizational.vue?vue&type=script&lang=js"
export * from "./ProcessOrganizational.vue?vue&type=script&lang=js"
import style0 from "./ProcessOrganizational.vue?vue&type=style&index=0&id=06cd0c90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cd0c90",
  null
  
)

export default component.exports